export default __webpack_public_path__ + "static/media/innerdesignersbanner.c03e12bd.jfif";